/* eslint-disable complexity */
import {
  BestFareOption,
  BookWidgetAem,
  BookWidgetBestFareOptionsField
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Option } from '@com-delta-omnichannel/mach';
import {
  ExcludeBasicFareBrandId,
  ExcludeBasicMainBrandId
} from '../../constants/fields-rules.constants';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { CatalogApiFieldsValue } from '../../models/core-apis/catalog-api.interfaces';
import { DefaultLookupFieldsValue } from '../../models/core-apis/default-lookup.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { QueryParams } from '../../models/states/query-params-state.interfaces';

export const prepareBestFareOptionsField = (
  bookWidgetAem: BookWidgetAem | null,
  queryParams: QueryParams | null,
  catalogApiFieldsValue: CatalogApiFieldsValue | null,
  defaultLookupFieldsValue: DefaultLookupFieldsValue | null,
  retrieveSearchData: RetrieveSearchData | null,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  hasDeepLinkingParams: boolean
): BookWidgetBestFareOptionsField => {
  if (bookWidgetFieldsMasterConfig.bestFareOptionsField?.hide) {
    return {
      disable: false,
      dropdownOptions: [],
      hide: true,
      selectedBestFare: ''
    };
  }

  let bestFareOptions: BestFareOption[] = [];
  if (defaultLookupFieldsValue?.bestFareOptions?.length) {
    bestFareOptions = defaultLookupFieldsValue.bestFareOptions;
  } else if (catalogApiFieldsValue?.bestFareOptions?.length) {
    bestFareOptions = catalogApiFieldsValue.bestFareOptions;
  } else if (bookWidgetAem?.defaultValues?.bestFareOptions) {
    bestFareOptions = bookWidgetAem.defaultValues.bestFareOptions;
  }

  // When basicFaresField.hide is false, filter out BE and BMAIN
  if (!bookWidgetFieldsMasterConfig.basicFaresField?.hide) {
    bestFareOptions = bestFareOptions.filter(
      ({ brandID }) =>
        brandID !== ExcludeBasicFareBrandId &&
        brandID !== ExcludeBasicMainBrandId
    );
  }

  const dropdownOptions: Option[] = [];
  bestFareOptions.forEach((bestFareOption) => {
    dropdownOptions.push({
      label: bestFareOption.brandName,
      value: bestFareOption.brandID
    });
  });

  let selectedBestFare = '';
  if (
    !bookWidgetFieldsMasterConfig?.bestFareOptionsField?.disable &&
    queryParams?.cabinFareClass
  ) {
    selectedBestFare = queryParams.cabinFareClass;
  } else if (
    !hasDeepLinkingParams &&
    !bookWidgetFieldsMasterConfig?.bestFareOptionsField?.disable &&
    retrieveSearchData?.faresFor
  ) {
    selectedBestFare = retrieveSearchData.faresFor;
  }

  let indexOfSelectedBestFare = -1;
  if (selectedBestFare) {
    indexOfSelectedBestFare = dropdownOptions.findIndex(
      ({ value }) => value === selectedBestFare
    );
  }

  if (indexOfSelectedBestFare === -1) {
    selectedBestFare = dropdownOptions[0].value;
    dropdownOptions[0].selected = true;
  } else {
    dropdownOptions[indexOfSelectedBestFare].selected = true;
  }

  return {
    dropdownOptions,
    selectedBestFare,
    disable:
      bookWidgetFieldsMasterConfig.bestFareOptionsField?.disable || false,
    hide: bookWidgetFieldsMasterConfig.bestFareOptionsField?.hide || false
  };
};
